module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Jss5zh/cover.jpeg?1738887728916",
      "alt": "This image is the cover for the book Echoes of Existence"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Echoes of Existence\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Embark on a thought-provoking journey with Echoes of Existence: Exploring Life’s Great Questions by Carlos Kuhn. Delving into the intersection of mathematics, philosophy, and spirituality, Kuhn explores profound questions about God, human existence, and the acquisition of knowledge. Through captivating insights and rigorous inquiry, this book challenges conventional thinking and invites readers to contemplate the very essence of reality. Join Kuhn as he navigates the complexities of existence and unlocks new perspectives on the nature of consciousness and the universe.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carlos Kuhn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carlos Kuhn is an accomplished philosopher, scientist, and writer with a passion for exploring the depths of human existence. With a background in mathematics and quantum physics, Carlos is a leading researcher in open-source technology, serving as the Research Chair on Open-Source Technology and an Associate Professor at the University of Canberra. His pioneering work focuses on quantum machine learning and cognitive AI, challenging traditional paradigms and inspiring profound insights into the nature of consciousness and reality. His work aims to inspire readers to ponder the mysteries of life and consciousness.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0